import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import { DestaquesGrid } from 'volto-ministerio-publico-federal/components/View/CapaView/DestaquesGrid';
import type { DestaquesData } from 'volto-ministerio-publico-federal/components/View/CapaView/helpers';

interface MpfDestaquesBlockViewProps {
  data: DestaquesData & { placeholder?: string };
  onEditItem?: (index: number) => void;
}

const EMPTY_TEXT =
  'Sem destaques curados. Na capa, as últimas notícias preenchem a grade automaticamente.';

/**
 * Bloco "Destaques (capa)".
 *
 * Fora da capa (no editor da Home) renderiza só a curadoria: o fallback de
 * notícias depende do `@search` disparado pela `CapaView`, não pelo bloco.
 * Sem itens, mostra o `placeholder` gravado no bloco — senão o bloco ficaria
 * invisível e o editor não conseguiria selecioná-lo.
 */
const MpfDestaquesBlockView = ({
  data,
  onEditItem,
}: MpfDestaquesBlockViewProps) => {
  if (!data?.items?.length) {
    return (
      <section className="rounded-md border border-dashed border-gray-300 p-4 dark:border-night-850">
        <h2 className="text-lg font-semibold text-on-surface-high dark:text-white">
          Destaques
        </h2>
        <p className="mt-1 text-sm text-gray-500 dark:text-night-400">
          {data?.placeholder || EMPTY_TEXT}
        </p>
      </section>
    );
  }

  /* `isEditMode={!!onEditItem}`, e não cravado em `true`: só o `Edit.tsx` passa
     `onEditItem`. Cravado, a página PUBLICADA herdava o comportamento de
     edição — slots vazios apareciam e os cards deixavam de ser links (ver os
     usos de `isEditMode` em `View/CapaView`). */
  return (
    <DestaquesGrid
      data={data}
      isEditMode={!!onEditItem}
      onEditItem={onEditItem}
    />
  );
};

export default withBlockExtensions(MpfDestaquesBlockView);
